import { api } from './api';
import type { RecurringAction, RecurringActionCreate, RecurringActionUpdate } from '../types';

export const recurringActionService = {
  list: async (includeSystem?: boolean): Promise<RecurringAction[]> => {
    const response = await api.get<RecurringAction[]>('/recurring-actions/', {
      params: includeSystem ? { include_system: true } : undefined,
    });
    return response.data;
  },

  create: async (data: RecurringActionCreate): Promise<RecurringAction> => {
    const response = await api.post<RecurringAction>('/recurring-actions/', data);
    return response.data;
  },

  update: async (id: string, data: RecurringActionUpdate): Promise<RecurringAction> => {
    const response = await api.put<RecurringAction>(`/recurring-actions/${id}`, data);
    return response.data;
  },

  pause: async (id: string): Promise<RecurringAction> => {
    const response = await api.post<RecurringAction>(`/recurring-actions/${id}/pause`);
    return response.data;
  },

  resume: async (id: string): Promise<RecurringAction> => {
    const response = await api.post<RecurringAction>(`/recurring-actions/${id}/resume`);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/recurring-actions/${id}`);
  },

  listQstashSchedules: async (): Promise<QstashSchedulesResponse> => {
    const response = await api.get<QstashSchedulesResponse>('/recurring-actions/qstash/schedules');
    return response.data;
  },

  deleteQstashSchedule: async (scheduleId: string): Promise<void> => {
    await api.delete(`/recurring-actions/qstash/schedules/${scheduleId}`);
  },
};

export interface QstashScheduleInfo {
  schedule_id: string | null;
  destination: string | null;
  cron: string | null;
  orphan: boolean;
}

export interface QstashSchedulesResponse {
  total: number;
  orphans: number;
  schedules: QstashScheduleInfo[];
}
